import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useParams, useSearchParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { PinScreen } from './PinScreen';
import { GuestLayout } from './GuestLayout';
import { guestApi } from './guestApi';
import { recordScan } from '../services/dataService';
import PaelbiHome from '../pages/PaelbiHome';
import Eventi from '../pages/Eventi';
import VicinoATe from '../pages/VicinoATe';
import ArteMusei from '../pages/ArteMusei';
import Servizi from '../pages/Servizi';
import Esperienze from '../pages/Esperienze';
import InfoBnb from '../pages/InfoBnb';

const Center = ({ children }) => (
  <div className="flex min-h-screen items-center justify-center bg-paelbi-bg px-4 text-center text-paelbi-ink/60">{children}</div>
);

export function GuestPortalApp() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const { reloadConfig } = useLanguage();
  const [state, setState] = useState('loading'); // loading | pin | granted | notfound
  const [meta, setMeta] = useState({ brand: '', logo: null });

  useEffect(() => {
    const preview = params.get('preview') === '1';
    if (preview) sessionStorage.setItem(`guest_preview_${token}`, '1');
    if (params.get('src') === 'qr') recordScan({ token, source: 'guest' });
    let active = true;
    guestApi.config(token).then((cfg) => {
      if (!active) return;
      setMeta({ brand: cfg.tenant?.brand?.name, logo: cfg.tenant?.logo_url });
      if (reloadConfig) reloadConfig();
      if (preview) { setState('granted'); return; }
      setState(cfg.authenticated ? 'granted' : 'pin');
    }).catch(() => { if (active) setState('notfound'); });
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  if (state === 'loading') return <Center>Caricamento...</Center>;
  if (state === 'notfound') {
    return <Center><div><p className="font-display text-2xl text-paelbi-ink">Struttura non trovata</p><p className="mt-2 text-sm">Il codice QR non è valido o è stato rigenerato.</p></div></Center>;
  }
  if (state === 'pin') {
    return <PinScreen token={token} brand={meta.brand} logo={meta.logo}
      onSuccess={() => { if (reloadConfig) reloadConfig(); setState('granted'); }} />;
  }

  return (
    <Routes>
      <Route path="/" element={<GuestLayout />}>
        <Route index element={<PaelbiHome />} />
        <Route path="eventi" element={<Eventi />} />
        <Route path="vicino-a-te" element={<VicinoATe />} />
        <Route path="arte-musei" element={<ArteMusei />} />
        <Route path="servizi" element={<Servizi />} />
        <Route path="esperienze" element={<Esperienze />} />
        <Route path="info-bnb" element={<InfoBnb />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Route>
    </Routes>
  );
}

export default GuestPortalApp;
